/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Complete_ToastInputs */

const en_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio embed export complete`)
};

const fr_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de l'intégration audio terminée`)
};

const de_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio-Einbettungs-Export abgeschlossen`)
};

const it_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione del contenuto audio incorporata completata.`)
};

const ru_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт встраивания аудио завершен.`)
};

const es_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de inserción de audio completada`)
};

const zh_cn2_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频嵌入导出完成`)
};

const ja_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声埋め込みのエクスポートが完了しました`)
};

const hi_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो एम्बेड निर्यात पूर्ण`)
};

const pt_pt2_audio_embed_export_complete_toast = /** @type {(inputs: Audio_Embed_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de áudio incorporado concluída`)
};

/**
* | output |
* | --- |
* | "Audio embed export complete" |
*
* @param {Audio_Embed_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_complete_toast = /** @type {((inputs?: Audio_Embed_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_complete_toast(inputs)
	if (locale === "de") return de_audio_embed_export_complete_toast(inputs)
	if (locale === "it") return it_audio_embed_export_complete_toast(inputs)
	if (locale === "ru") return ru_audio_embed_export_complete_toast(inputs)
	if (locale === "es") return es_audio_embed_export_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_complete_toast(inputs)
	if (locale === "ja") return ja_audio_embed_export_complete_toast(inputs)
	if (locale === "hi") return hi_audio_embed_export_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_complete_toast(inputs)
	return en_audio_embed_export_complete_toast(inputs)
});